module.exports = __webpack_public_path__ + "static/media/img3.f5fcad65.jpg";